export const AVAILABLE_LANGS = ["en", "es", "pt", "ru", "fr"];

/**
 * Colores por nivel HSK (1-7) usados en caracteres chinos y stats.
 * Fuente única para mantener consistencia visual.
 */
export const HSK_LEVEL_COLORS = {
  1: "#83BF6E", // verde - HSK1
  2: "#78CEFF", // azul - HSK2
  3: "#5E5BF6", // púrpura - HSK3
  4: "#EDE63E", // amarillo - HSK4
  5: "#F0B43F", // naranja - HSK5
  6: "#F05D5D", // rojo - HSK6
  7: "#C055E5", // rosa/púrpura - HSK7
};

/** Array ordenado para gráficos y barras de stats (nivel 1 → 7) */
export const LEVEL_CHART_COLORS = Object.keys(HSK_LEVEL_COLORS)
  .sort((a, b) => Number(a) - Number(b))
  .map((k) => HSK_LEVEL_COLORS[k]);

export const LANG_LABELS = {
  en: "English",
  es: "Español",
  fr: "Français",
  ru: "Русский",
  pt: "Português",
};

/**
 * Extrae la traducción para un idioma específico de un array de traducciones
 * @param {Array} translations - Array de objetos con {lang, trans, active}
 * @param {string} userLang - Idioma del usuario (por defecto 'en')
 * @returns {string} - La traducción o fallback a 'en' o primera disponible
 */
export const getTranslation = (translations, userLang = 'en') => {
  if (!translations || !Array.isArray(translations)) return 'Untitled';
  
  // Buscar traducción en el idioma del usuario
  let translation = translations.find(t => t?.lang === userLang && t?.active);
  if (translation?.trans) return translation.trans;
  
  // Fallback a inglés
  translation = translations.find(t => t?.lang === 'en' && t?.active);
  if (translation?.trans) return translation.trans;
  
  // Fallback a la primera traducción activa disponible
  translation = translations.find(t => t?.active && t?.trans);
  if (translation?.trans) return translation.trans;
  
  // Fallback final
  return translations[0]?.trans || 'Untitled';
};

/**
 * Obtiene el idioma del usuario desde localStorage o configuración
 * @returns {string} - Idioma del usuario (por defecto 'en')
 */
export const getUserLanguage = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.lang || 'en';
  } catch (error) {
    return 'en';
  }
};
